import { useEffect, useState } from "react";

import { Patient } from "@/Common/Models/Patient/Patient";
import { LabsHelper } from "@/Labs/Helpers/LabsHelper";
import { PatientLabsTab } from "@/Patient/Components/Labs/PatientLabsTab";
import { IPatientMedicalSummaryModel } from "@/Patient/Models/UI/MedicalSummary/IPatientMedicalSummaryModel";

import styles from "./PrescriptionRenewalsViewResults.module.scss";

interface PrescriptionRenewalsViewResultsProps {
    patientSummary: IPatientMedicalSummaryModel;
    patientProfile: Patient;
}

function PrescriptionRenewalsViewResults(props: PrescriptionRenewalsViewResultsProps): JSX.Element {
    const patientContactId = props.patientSummary?.get("PatientContactId");
    const [isImportLabModelFinished, setIsImportLabModelFinished] = useState<boolean>(false);

    useEffect(() => {
        const importModel = async (): Promise<void> => {
            if (!IsNullOrUndefined(patientContactId)) {
                await labsStore.ImportLabsModels(LabsHelper.BuildDefaultLabModelsForPatientProfile(patientContactId));
                setIsImportLabModelFinished(true);
            }
        };

        importModel();
    }, [patientContactId]);

    return (
        <div className={styles.labsContainer}>
            {isImportLabModelFinished && (
                <PatientLabsTab
                    patientId={patientContactId}
                    patient={props.patientProfile}
                    isReadOnly={true}
                />
            )}
        </div>
    );
}

export { PrescriptionRenewalsViewResults };
